module.exports = __webpack_public_path__ + "img/up-to-line.81c78b1e.svg";